import _ from 'lodash';

import { RESET_STATE } from 'store/global/actions';

import { PROGRAM_INDEX_TYPE_ACTION_TYPE } from '../actions';

const initialState = {};

const programIndexTypesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case PROGRAM_INDEX_TYPE_ACTION_TYPE.GET_PROGRAM_INDEX_TYPES:
      return payload || initialState;

    case PROGRAM_INDEX_TYPE_ACTION_TYPE.CREATE_PROGRAM_INDEX_TYPE:
    case PROGRAM_INDEX_TYPE_ACTION_TYPE.EDIT_PROGRAM_INDEX_TYPE:
      return { ...state, [payload.indexTypeId]: payload };

    case PROGRAM_INDEX_TYPE_ACTION_TYPE.DELETE_PROGRAM_INDEX_TYPE:
      return _.omit(state, payload);

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default programIndexTypesReducer;
